import React from "react";

import {
  StatistiqueHeader,
  SearchTable,
  Header,
  LoadingSpinner,
} from "./index";

function AllCompomentShared({
  libelleHeaderComp,
  titleStatisticHeaderComp,
  nbreTotalStatistiqueComp,
  SearchTableLibelleBtn,
  SearchTableIsBtn,
  SearchTableIsSearch,
  placeholderInputSearch,
  globalFilterValue,
  onGlobalFilterChange,
  SearchTableNameRouteBtn,
  SearchTableIconeBtn,
  SearchTableIsBtnExcel,
  SearchTableExportExcel,
  iconeStatistiqueHeader,
  isLoading,
  isReturn,
  isBtnFilter,
  btnFilterArray,
  children,
}) {
  if (isLoading) return <LoadingSpinner />;
  return (
    <div>
      <Header libelle={libelleHeaderComp} isReturn={isReturn ? true : false} />
      <div className="conteneur-page">
        <StatistiqueHeader
          title={titleStatisticHeaderComp}
          nbreTotal={nbreTotalStatistiqueComp}
          icone={iconeStatistiqueHeader}
        />
        <hr />
        <SearchTable
          libelleBtn={SearchTableLibelleBtn}
          btnFilterArray={btnFilterArray}
          isBtnFilter={isBtnFilter}
          isBtn={SearchTableIsBtn}
          isSearch={SearchTableIsSearch}
          placeholderInputSearch={placeholderInputSearch}
          globalFilterValue={globalFilterValue}
          handleChange={onGlobalFilterChange}
          nameRouteBtn={SearchTableNameRouteBtn}
          iconeBtn={SearchTableIconeBtn}
          isBtnExcel={SearchTableIsBtnExcel}
          exportExcel={SearchTableExportExcel}
        />
        {children}
      </div>
    </div>
  );
}

export default AllCompomentShared;
